(() => {
  if (customElements.get('pancha-localization')) return;

  class PanchaLocalization extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.addEventListener('toggle', (event) => {
        if (!event.target.matches('details[open]')) return;
        document.querySelectorAll('pancha-localization details[open]').forEach((details) => {
          if (details !== event.target) details.open = false;
        });
      }, { capture: true, signal });
      this.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('submit', (event) => {
        const returnTo = window.location.pathname + window.location.search + window.location.hash;
        event.target.querySelectorAll('input[name="return_to"]').forEach((input) => { input.value = returnTo; });
      }, { signal });
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) this.closePanels();
      }, { signal });
      document.addEventListener('focusin', (event) => {
        if (!this.contains(event.target)) this.closePanels();
      }, { signal });
      window.addEventListener('resize', () => this.closePanels(true), { signal });
    }

    disconnectedCallback() {
      this.controller.abort();
    }

    closePanels(restoreFocus = false) {
      this.querySelectorAll('details[open]').forEach((details) => {
        if (restoreFocus && details.contains(document.activeElement)) details.querySelector('summary').focus({ preventScroll: true });
        details.open = false;
      });
    }

    handleKeydown(event) {
      const details = event.target.closest('details');
      if (!details || !this.contains(details)) return;
      const summary = details.querySelector('summary');
      if (event.key === 'Escape' && details.open) {
        event.preventDefault();
        event.stopPropagation();
        details.open = false;
        summary.focus({ preventScroll: true });
        return;
      }
      const keys = ['ArrowDown', 'ArrowUp', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      const options = [...details.querySelectorAll('button:not(:disabled)')];
      if (!options.length) return;
      event.preventDefault();
      details.open = true;
      const current = options.indexOf(document.activeElement);
      let next;
      if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = options.length - 1;
      else if (current === -1) next = event.key === 'ArrowUp' ? options.length - 1 : 0;
      else next = (current + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
      options[next].focus();
    }
  }

  customElements.define('pancha-localization', PanchaLocalization);
})();
